import { render, staticRenderFns } from "./EditLinkedTemplate.vue?vue&type=template&id=befe3f7a&scoped=true"
import script from "./EditLinkedTemplate.vue?vue&type=script&lang=js"
export * from "./EditLinkedTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditLinkedTemplate.vue?vue&type=style&index=0&id=befe3f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe3f7a",
  null
  
)

export default component.exports